import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types';

export const setFieldSettingsPrefixOrSuffixField: YJSChangeHandler<
  DatabaseChangeType.SET_FIELD_SETTINGS_PREFIX_OR_SUFFIX_FIELD
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    if (change.changeType === 'prefix') {
      db.fieldsById[change.fieldId].customNumberFormat.prefix = change.newValue;
    } else if (change.changeType === 'suffix') {
      db.fieldsById[change.fieldId].customNumberFormat.suffix = change.newValue;
    }
  });
};
